/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Erc20__factory } from "./Erc20__factory";
export { Multicall2__factory } from "./Multicall2__factory";
